import React from "react";
import Loadable from "react-loadable";
import EmptyLoading from "../../components/empty-loading";

const LeadsLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "page-leads" */
      /* webpackMode: "lazy" */
      "./../leads"
    ),
  loading: EmptyLoading,
});

export default LeadsLoadable;
